import React from 'react';
import WishlistHeart from '@core/scripts/components/wishlist/heart';

function AlpiWishlistHeart({
    digistyleId,
    articleNumber,
    itemId,
    shopId,
    articlePrice,
    masterStyleId,
    promotion,
    origin,
}) {
    //TODO: Error Handling, Landmarks, Disabled
    return (
        <WishlistHeart
            className="article-overview__add-to-wishlist-heart"
            digistyleId={digistyleId}
            articleNumber={articleNumber} //griditem.styles.colors.itemnumber
            promotion={promotion}
            shopId={shopId}
            itemId={itemId} // griditem.id
            origin={origin}
            articlePrice={articlePrice}
            masterStyleId={masterStyleId}
        />
    );
}

export default React.memo(AlpiWishlistHeart);